var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcerocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_26796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18194 7.39234L1.83642 7.39227C1.65824 7.39226 1.56901 7.17684 1.695 7.05085L3.88904 4.85681C4.07658 4.66927 4.33093 4.56391 4.59615 4.56391L8.2341 4.56391C8.35606 4.56391 8.47303 4.51546 8.55926 4.42923L9.46842 3.52007C10.6111 2.37742 12.1608 1.73549 13.7768 1.73549V1.73549C13.945 1.73549 14.0814 1.87188 14.0814 2.04013V2.04013C14.0814 3.65608 13.4395 5.20585 12.2968 6.34849L11.3877 7.25765C11.3015 7.34389 11.253 7.46086 11.253 7.58282L11.253 11.2208C11.253 11.486 11.1476 11.7403 10.9601 11.9279L8.76607 14.1219C8.64008 14.2479 8.42466 14.1587 8.42465 13.9805L8.42458 11.635M7.71747 8.09945L4.53549 11.2814",
    stroke: "#898EA2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_26796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcerocket);
export default __webpack_public_path__ + "static/media/resource.rocket.c2891dea74769054f008b90ba707aed2.svg";
export { ForwardRef as ReactComponent };